import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';

// Components
import { WpModal, WpModalHeader, WpModalBody, WpModalFooter } from 'Wpds/components/modal';
import { WpButtonGroup, WpButton } from 'Wpds/components/button';
import { WpForm, WpFormLayout } from 'Wpds/components/form';
import { VisuallyHidden } from 'Wpds/components/visually-hidden/VisuallyHidden';
import WpTextField from 'Wpds/components/text-field/WpTextField';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

type Props = {
  isOpen?: boolean;
  toggleIsOpen?: () => void;
};

const ConnectServicenowModal = ({ isOpen, toggleIsOpen }: Props) => {
  const { tr } = useTranslation();
  const btnRef = useRef(null);

  const servicenowDataSource = useSelector(state => state.data_sources.find(({ slug }) => slug === 'servicenow'));

  const handleSubmitClick = () => {
    btnRef.current.click();
  };

  const csrfValue = get(document.getElementsByName('csrf-token')[0], 'content');
  return (
    <WpModal isOpen={isOpen} size="sm" onToggle={toggleIsOpen}>
      <WpModalHeader>{tr('perform.connect.servicenow.title')}</WpModalHeader>
      <WpModalBody>
        <WpForm method="post" action={servicenowDataSource.path}>
          <WpFormLayout>
            <WpTextField
              id="client_id"
              name="client_id"
              label={tr('perform.connect.servicenow.client_id_label')}
              required
            />
            <WpTextField
              id="client_secret"
              type="password"
              name="client_secret"
              label={tr('perform.connect.servicenow.client_secret_label')}
              required
            />
            <WpTextField
              id="subdomain"
              name="subdomain"
              label={tr('perform.connect.servicenow.subdomain_label')}
              required
            />
            <div style={{ visibility: 'hidden', height: '0px', position: 'absolute', top: '-1000px', left: '-1000px' }}>
              <WpTextField type="text" id="authenticity_token" label="authenticity_token" value={csrfValue} readOnly />
            </div>
            <VisuallyHidden>
              <WpButton btnType="submit" ref={btnRef}>
                {tr('perform.common.submit')}
              </WpButton>
            </VisuallyHidden>
          </WpFormLayout>
        </WpForm>
      </WpModalBody>
      <WpModalFooter>
        <WpButtonGroup>
          <WpButton variant="tertiary" onClick={toggleIsOpen}>
            {tr('perform.common.cancel')}
          </WpButton>
          <WpButton onClick={handleSubmitClick}>{tr('perform.common.save')}</WpButton>
        </WpButtonGroup>
      </WpModalFooter>
    </WpModal>
  );
};

export default ConnectServicenowModal;
